import { get } from 'src/utils/fetch';
import { configuration } from 'src/configuration';
import { store } from 'src/store';
import { selectAuthToken } from 'src/store/selectors';
import { to } from 'to-await';
import { ConceptCodesResponse } from './concept-codes.dto';

export const BASE_PATH = 'concept-codes';

export const getConceptCodes = async ({
  jobId,
}: {
  jobId: string;
}): Promise<ConceptCodesResponse> => {
  const url = `${configuration.accountApiUrl}/${BASE_PATH}/${jobId}`;

  const [error, response] = await to(
    get(url, {
      headers: {
        Authorization: `Bearer ${selectAuthToken(store.getState())}`,
      },
    }),
  );

  if (error) {
    throw new Error(error.message);
  }

  return response;
};
